import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { BgImage } from 'gbimage-bridge';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '50vh',
    minHeight: 480,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [theme.breakpoints.down('sm')]: {
      height: '70vh',
    },
  },
}));

const BackgroundImage = ({ bgImage, customClass, children }) => {
  const classes = useStyles();

  return (
    <BgImage image={bgImage} className={`${classes.root} ${customClass}`}>
      {children}
    </BgImage>
  );
};

export default BackgroundImage;
